<template>
	<el-main class="custom-main" :class="($route.name == 'iframe' ? 'custom-main-iframe' : false )">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</el-main>
</template>
<script>
	export default {
		name: 'Content'
	}
</script>
<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s
	}

	.fade-enter,
	.fade-leave-to  {
		opacity: 0
	}
	.custom-main{
		background: #FFF;
		margin-left: 80px;
		position: relative;
		min-height: calc(100vh);
		transition: all 0.3s ease-out;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Content.vue